export default "__VITE_ASSET__ByTtcceD__"